export const vowels_mg = [
  { kor: "ㅏ", rom: "a" },
  { kor: "ㅑ", rom: "ya" },
  { kor: "ㅓ", rom: "eo" },
  { kor: "ㅕ", rom: "yeo" },
  { kor: "ㅗ", rom: "o" },
  { kor: "ㅛ", rom: "yo" },
  { kor: "ㅜ", rom: "u" },
  { kor: "ㅠ", rom: "yu" },
  { kor: "ㅡ", rom: "eu" },
  { kor: "ㅣ", rom: "i" },
  { kor: "ㅐ", rom: "ae" },
  { kor: "ㅒ", rom: "yae" },
  { kor: "ㅔ", rom: "e" },
  { kor: "ㅖ", rom: "ye" },
  { kor: "ㅘ", rom: "wa" },
  { kor: "ㅙ", rom: "wae" },
  { kor: "ㅚ", rom: "oe" },
  { kor: "ㅝ", rom: "wo" },
  { kor: "ㅞ", rom: "we" },
  { kor: "ㅟ", rom: "wi" },
  { kor: "ㅢ", rom: "ui" },
];


export const consonants_mg = [
  { kor: "ㄱ", rom: "g/k" },
  { kor: "ㄲ", rom: "kk" },
  { kor: "ㄴ", rom: "n" },
  { kor: "ㄷ", rom: "d/t" },
  { kor: "ㄸ", rom: "tt" },
  { kor: "ㄹ", rom: "r/l" },
  { kor: "ㅁ", rom: "m" },
  { kor: "ㅂ", rom: "b/p" },
  { kor: "ㅃ", rom: "pp" },
  { kor: "ㅅ", rom: "s" },
  { kor: "ㅆ", rom: "ss" },
//   { kor: "ㅇ", rom: "ng/silent" }, too large, on hold
  { kor: "ㅈ", rom: "j" },
  { kor: "ㅉ", rom: "jj" },
  { kor: "ㅊ", rom: "ch" },
  { kor: "ㅋ", rom: "k" },
  { kor: "ㅌ", rom: "t" },
  { kor: "ㅍ", rom: "p" },
  { kor: "ㅎ", rom: "h" },
];


export const pairs_mg = [
  { kor: "가", rom: "ga" },
  { kor: "나", rom: "na" },
  { kor: "다", rom: "da" },
  { kor: "라", rom: "ra" },
  { kor: "마", rom: "ma" },
  { kor: "바", rom: "ba" },
  { kor: "사", rom: "sa" },
  { kor: "아", rom: "a" },
  { kor: "자", rom: "ja" },
  { kor: "차", rom: "cha" },
  { kor: "카", rom: "ka" },
  { kor: "타", rom: "ta" },
  { kor: "파", rom: "pa" },
  { kor: "하", rom: "ha" },
  { kor: "까", rom: "kka" },
  { kor: "따", rom: "tta" },
  { kor: "빠", rom: "ppa" },
  { kor: "싸", rom: "ssa" },
  { kor: "짜", rom: "jja" },
];
